<template>
    <div class="signed">
        <a-table class="stock-table" :columns="table.columns" :data-source="table.data" :loading="table.loading"
            :pagination="table.pagination" rowKey="id" @change="tableChanged" bordered>
            
            <div slot="time" slot-scope="time">
                {{ formatTime(time) }}
            </div>

            <div slot="signTime" slot-scope="signTime">
                {{ formatSec(signTime) }}
            </div>
            <div slot="memberInfo" class="info-box" slot-scope="val,info">
                <img :src="info.ast_member.avatar">
                <span>{{ info.ast_member.mark_name || info.ast_member.name }}</span>
            </div>
            <div slot="op" class="btn-groups" slot-scope="val,item">
                <img src="/assets/images/contract-icon-look.png" @click="lookContract(item)">
                <img src="/assets/images/contract-icon-down.png" @click="downContract(item)">
            </div>

        </a-table>
    </div>
</template>
<script>
import api from '@/repo/api';
import moment from "moment/moment";
export default {
    name: "signed",
    data() {
        return {
            table: {
                columns: [
                    {
                        width: 70,
                        title: '序号',
                        dataIndex: 'num',
                        align: 'center',
                        customRender: (text,record,index) => `${index+1}`,
                    },
                    {
                        width: 140,
                        title: '合同设定时间',
                        dataIndex: 'created_at',
                        scopedSlots: {customRender: 'time'},
                        align: 'center',
                    },
                    {
                        width: 200,
                        title: '模板合同名称',
                        dataIndex: 'title',
                        align: 'center',
                        ellipsis:true,
                    },
                    {
                        width: 110,
                        title: '签署用户',
                        dataIndex: 'memberInfo',
                        align: 'center',
                        ellipsis:true,
                        scopedSlots: { customRender: 'memberInfo' },
                    },
                    {
                        width: 110,
                        title: '签署人姓名',
                        dataIndex: 'name',
                        align: 'center',
                        ellipsis:true,
                    },
                    {
                        width: 110,
                        title: '合同编号',
                        dataIndex: 'sign_id',
                        align: 'center',
                        ellipsis:true,
                    },
                    {
                        width: 140,
                        title: '合同签署时间',
                        dataIndex: 'sign_at',
                        align: 'center',
                        ellipsis:true,
                        scopedSlots: {customRender: 'signTime'},
                    },
                    {
                        width: 100,
                        title: '操作',
                        dataIndex: 'op',
                        align: 'center',
                        scopedSlots: { customRender: 'op' },
                    }
                ],
                loading: true,
                data: [],
                pagination: {
                    defaultCurrent: 1,
                    current: 1,
                    defaultPageSize: 10,
                    total: 1,
                    pageSize: 20
                },
            },
            query: {
                page: 1,
            }
        }
    },
    mounted() {
        this.getList();
    },
    methods: {
        // 表格分页
        tableChanged(pagination) {
            this.query.page = pagination.current;
            this.getList();
        },
        // 获取列表数据
        getList() {
            this.table.loading = true;
            api.get('/ast-contract/signed-list',this.query, (res) => {
                if (res.code === 0) {
                    this.table.data = res.data.data;
                    this.table.loading = false;
                } else {
                    this.$message.error(res.msg);
                }
            }); 
        },
        // 查看
        lookContract(item) {
            api.post('/ast-contract/pdf-download-url',{sign_id:item.sign_id}, (res) => {
                if (res.code == 0) {
                    let url = res.data.url;
                    window.open(url);
                } else {
                    this.$message.error(res.msg);
                }
            }); 
        },
        // 下载
        downContract(item) {
            api.post('/ast-contract/pdf-download-url',{sign_id:item.sign_id}, (res) => {
                if (res.code == 0) {
                    let url = res.data.url;
                    this.downloadFile(item.title,url);
                } else {
                    this.$message.error(res.msg);
                }
            }); 
        },
        async downloadFile(name,pdfUrl) {
            try {
                const response = await fetch(pdfUrl);
                if (!response.ok) throw new Error('Failed to fetch PDF');
                        
                const blob = await response.blob();

                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = name+'.pdf'; 
                
                document.body.appendChild(a);
                a.click();
                
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);

                this.$message.success('下载成功！');
                
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        formatTime(time) {
            return moment(time).format('yyyy-MM-DD HH:mm')
        },
        formatSec(time) {
            return moment(time * 1000).format('yyyy-MM-DD HH:mm:ss')
        }
    }
}
</script>

<style lang="less" scoped>
    .btn-groups{
        width: 72px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 auto;
        img{
            width: 24px;
            height: 24px;
        }
    }
    .info-box{
        display: flex;
        align-items: center;
        justify-content: center;
        img{
            width: 24px;
            height: 24px;
            border-radius: 50%;
            border: 1px solid #dfdfdf;
            margin-right: 4px;
        }
    }
</style>